<av-content-container>
  <div class="history-header d-flex align-items-center justify-content-between px-4 gap-3 flex-wrap">
    <div class="d-flex align-items-center gap-3">
      <h2 class="page-title m-0">{{ 'app.autopilot_devices.history.title' | translate }}</h2>

      <button mat-icon-button (click)="loadHistory()"
        class="d-flex align-items-center justify-content-center focus-outline-none"
        [matTooltip]="'shared.general.tooltips.refresh' | translate" [disabled]="isLoading()">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>

    <a routerLink="/autopilot-devices" mat-icon-button
      class="d-flex align-items-center justify-content-center focus-outline-none"
      [matTooltip]="'app.autopilot_devices.table.close' | translate">
      <mat-icon>close</mat-icon>
    </a>
  </div>

  @if (isLoading()) {
  <div class="loading-state d-flex flex-column align-items-center justify-content-center gap-3 py-5">
    <mat-spinner diameter="40"></mat-spinner>
    <span>{{ 'app.autopilot_devices.history.loading' | translate }}</span>
  </div>
  } @else if (error()) {
  <div class="error-state p-3">
    <mat-icon>error_outline</mat-icon>
    <span>{{ error()! | translate }}</span>
  </div>
  } @else {
  <av-table-card titleKey="app.autopilot_devices.history.table_title" icon="history" [columns]="tableColumns"
    [rows]="tableRows()" emptyTextKey="app.autopilot_devices.history.no_data" [pageSize]="10" />
  }
</av-content-container>